var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-info-description html-content" }, [
    _c("h2", [_vm._v("Описание")]),
    _c("div", { domProps: { innerHTML: _vm._s(_vm.PRODUCT.description) } }),
    _c("div", { domProps: { innerHTML: _vm._s(_vm.material) } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }